export default __webpack_public_path__ + "static/media/Future Learn UX.04447b77.webp";